module.exports = __webpack_public_path__ + "lp/img/prev-brand.8904cddc.svg";